/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listExpensesReadyToBillOpenAssignments = /* GraphQL */ `
  query ListExpensesReadyToBillOpenAssignments(
    $limit: Int
    $lob: String
    $lastEvaluatedKey: String
  ) {
    listExpensesReadyToBillOpenAssignments(
      limit: $limit
      lob: $lob
      lastEvaluatedKey: $lastEvaluatedKey
    ) {
      list {
        id
        createdAt
        code
        driverId
        driverName
        assignmentId
        customerId
        customerName
        branch
        costCenter
        startDate
        endDate
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        totalToBeBilled
        totalReceiptAmount
        documentName
        documentSize
        expenseItem {
          documentName
          documentSize
          __typename
        }
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const listExpensesReadyToBillClosedAssignments = /* GraphQL */ `
  query ListExpensesReadyToBillClosedAssignments(
    $limit: Int
    $lob: String
    $lastEvaluatedKey: String
  ) {
    listExpensesReadyToBillClosedAssignments(
      limit: $limit
      lob: $lob
      lastEvaluatedKey: $lastEvaluatedKey
    ) {
      list {
        id
        createdAt
        code
        driverId
        driverName
        assignmentId
        customerId
        customerName
        branch
        costCenter
        startDate
        endDate
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        totalToBeBilled
        totalReceiptAmount
        documentName
        documentSize
        expenseItem {
          documentName
          documentSize
          __typename
        }
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const listExpensesReadyToBillTransferToUltraStaff = /* GraphQL */ `
  query ListExpensesReadyToBillTransferToUltraStaff(
    $limit: Int
    $lob: String
    $driverId: Int
    $assignmentId: Int
    $code: String
    $customerId: Int
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $lastEvaluatedKey: String
  ) {
    listExpensesReadyToBillTransferToUltraStaff(
      limit: $limit
      lob: $lob
      driverId: $driverId
      assignmentId: $assignmentId
      code: $code
      customerId: $customerId
      startDate: $startDate
      endDate: $endDate
      lastEvaluatedKey: $lastEvaluatedKey
    ) {
      list {
        id
        createdAt
        code
        driverId
        driverName
        assignmentId
        customerId
        customerName
        branch
        costCenter
        startDate
        endDate
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        totalToBeBilled
        totalReceiptAmount
        documentName
        documentSize
        expenseItem {
          documentName
          documentSize
          __typename
        }
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const report = /* GraphQL */ `
  query Report($input: ReportInput!) {
    report(input: $input) {
      id
      status
      statusCode
      statusDescription
      location
      __typename
    }
  }
`;
export const listClientDriverQualificationsByStatus = /* GraphQL */ `
  query ListClientDriverQualificationsByStatus(
    $limit: Int
    $lastEvaluatedKey: String
    $userId: String
    $status: String
  ) {
    listClientDriverQualificationsByStatus(
      limit: $limit
      lastEvaluatedKey: $lastEvaluatedKey
      userId: $userId
      status: $status
    ) {
      list {
        id
        driverId
        driverName
        locationCity
        locationState
        status
        dqOwnerFullName
        dqClientApproverUserFullName
        name
        createdAt
        updatedAt
        fileType
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const listExpenseSearch = /* GraphQL */ `
  query ListExpenseSearch(
    $limit: Int
    $lob: String
    $status: String
    $code: String
    $branch: Int
    $costCenter: Int
    $customerId: Int
    $driverId: Int
    $notes: String
    $assignmentId: Int
    $endDate: String
    $createdAt: String
    $payWeekEnding: String
    $documentName: String
    $expenseItemHotelId: String
    $expenseItemHotelStateId: String
    $expenseItemHotelCityId: String
    $expenseItemAirLineId: String
    $expenseItemCarRentalCompanyId: String
    $lastEvaluatedKey: String
    $creditCardHolderName: String
  ) {
    listExpenseSearch(
      limit: $limit
      lob: $lob
      status: $status
      code: $code
      branch: $branch
      costCenter: $costCenter
      customerId: $customerId
      driverId: $driverId
      notes: $notes
      assignmentId: $assignmentId
      endDate: $endDate
      createdAt: $createdAt
      payWeekEnding: $payWeekEnding
      documentName: $documentName
      expenseItemHotelId: $expenseItemHotelId
      expenseItemHotelStateId: $expenseItemHotelStateId
      expenseItemHotelCityId: $expenseItemHotelCityId
      expenseItemAirLineId: $expenseItemAirLineId
      expenseItemCarRentalCompanyId: $expenseItemCarRentalCompanyId
      lastEvaluatedKey: $lastEvaluatedKey
      creditCardHolderName: $creditCardHolderName
    ) {
      list {
        id
        createdAt
        code
        driverId
        driverName
        assignmentId
        customerId
        customerName
        branch
        costCenter
        startDate
        endDate
        invoiceDate
        payWeekEnding
        totalToBeBilled
        totalReceiptAmount
        status
        updatedAt
        statementDate
        expenseReportAppropriationNbr
        variance
        nonBillable
        invoiceNumber
        invoicePaid
        totalProjectedAmount
        expenseItem {
          projectedAmount
          dailyCharge
          projectedDays
          creditCardHolderName
          paidThrough
          receiptAmount
          hotelConfirmationNumber
          hotelPhoneNumber
          hotelState
          __typename
        }
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const listExpenseSearchOptions = /* GraphQL */ `
  query ListExpenseSearchOptions($lob: String) {
    listExpenseSearchOptions(lob: $lob) {
      drivers {
        driverId
        driverName
        __typename
      }
      customers {
        customerId
        customerName
        __typename
      }
      assignments {
        assignmentId
        __typename
      }
      __typename
    }
  }
`;
export const getDriversCountForPushNotification = /* GraphQL */ `
  query GetDriversCountForPushNotification(
    $type: String
    $status: String
    $lob: String
    $branch: String
    $recipientStatus: String
  ) {
    getDriversCountForPushNotification(
      type: $type
      status: $status
      lob: $lob
      branch: $branch
      recipientStatus: $recipientStatus
    ) {
      responseCode
      responseMessage
      driverCount
      __typename
    }
  }
`;
export const verifyRoute = /* GraphQL */ `
  query VerifyRoute($route: String, $roleId: Int) {
    verifyRoute(route: $route, roleId: $roleId) {
      authorized
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      name
      customerId
      status
      type
      lastLogin
      clientName
      updateDriverQualifications
      StandardDocuments {
        items {
          id
          for
          forName
          category
          type
          customerId
          driverId
          documentName
          accountMasterCode
          createdAt
          updatedAt
          userStandardDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      Audit {
        items {
          id
          event
          eventTime
          objectName
          objectId
          objectData
          createdAt
          updatedAt
          userAuditId
          __typename
        }
        nextToken
        __typename
      }
      appAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      cellPhone
      passwordChangeDate
      preferredMFA
      lastResetMFA
      customersAddedByAmc
      customers {
        items {
          id
          customerId
          active
          createdAt
          updatedAt
          userCustomersId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserCustomer = /* GraphQL */ `
  query GetUserCustomer($id: ID!) {
    getUserCustomer(id: $id) {
      id
      customerId
      active
      createdAt
      updatedAt
      userCustomersId
      __typename
    }
  }
`;
export const listUserCustomers = /* GraphQL */ `
  query ListUserCustomers(
    $filter: ModelUserCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        active
        createdAt
        updatedAt
        userCustomersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDriverQualification = /* GraphQL */ `
  query GetDriverQualification($id: ID!) {
    getDriverQualification(id: $id) {
      id
      tier
      customerId
      name
      driverId
      driverName
      status
      jobId
      jobStartDate
      createEmail
      updateUser
      dqSpecialistUser
      dqSpecialistEmail
      createUserFullName
      dqOwnerFullName
      dqClientApproverUser
      dqClientApproverUserFullName
      dqDocumentName
      questions {
        items {
          id
          user
          text
          createUserFullName
          type
          status
          createdAt
          updatedAt
          driverQualificationQuestionsId
          __typename
        }
        nextToken
        __typename
      }
      driverQualificationServiceTeamNotes {
        items {
          id
          user
          text
          createUserFullName
          createdAt
          updatedAt
          driverQualificationDriverQualificationServiceTeamNotesId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      tierDescription
      branch
      driverSkillSummary
      locationState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      locationCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      driverQualificationChecklistDocuments {
        items {
          id
          item
          source
          category
          type
          order
          documentName
          createdAt
          updatedAt
          driverQualificationDriverQualificationChecklistDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      accountMasterCode
      checkListLevel
      fileType
      clientVisible
      updatedAt
      driverQualificationLocationStateId
      driverQualificationLocationCityId
      __typename
    }
  }
`;
export const listDriverQualifications = /* GraphQL */ `
  query ListDriverQualifications(
    $filter: ModelDriverQualificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverQualifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDriverQualificationsByStatusByCustomerIdAndCreatedBy = /* GraphQL */ `
  query ListDriverQualificationsByStatusByCustomerIdAndCreatedBy(
    $status: String!
    $customerIdCreatedAt: ModelDriverQualificationByStatusbycustomerIdbycreatedAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDriverQualificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverQualificationsByStatusByCustomerIdAndCreatedBy(
      status: $status
      customerIdCreatedAt: $customerIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDriverQualificationChecklistDocuments = /* GraphQL */ `
  query GetDriverQualificationChecklistDocuments($id: ID!) {
    getDriverQualificationChecklistDocuments(id: $id) {
      id
      item
      source
      category
      type
      order
      documentName
      driverQualificationSelectedDocuments {
        items {
          id
          item
          source
          category
          type
          pages
          order
          documentName
          for
          customerId
          driverId
          documentAutoSelected
          createdAt
          updatedAt
          driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationChecklistDocumentsId
      __typename
    }
  }
`;
export const listDriverQualificationChecklistDocuments = /* GraphQL */ `
  query ListDriverQualificationChecklistDocuments(
    $filter: ModelDriverQualificationChecklistDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverQualificationChecklistDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        item
        source
        category
        type
        order
        documentName
        driverQualificationSelectedDocuments {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        driverQualificationDriverQualificationChecklistDocumentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDriverQualificationSelectedDocuments = /* GraphQL */ `
  query GetDriverQualificationSelectedDocuments($id: ID!) {
    getDriverQualificationSelectedDocuments(id: $id) {
      id
      item
      source
      category
      type
      pages
      order
      documentName
      for
      customerId
      driverId
      documentAutoSelected
      createdAt
      updatedAt
      driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
      __typename
    }
  }
`;
export const listDriverQualificationSelectedDocuments = /* GraphQL */ `
  query ListDriverQualificationSelectedDocuments(
    $filter: ModelDriverQualificationSelectedDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverQualificationSelectedDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        item
        source
        category
        type
        pages
        order
        documentName
        for
        customerId
        driverId
        documentAutoSelected
        createdAt
        updatedAt
        driverQualificationChecklistDocumentsDriverQualificationSelectedDocumentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAtsDriverDocuments = /* GraphQL */ `
  query GetAtsDriverDocuments($id: ID!) {
    getAtsDriverDocuments(id: $id) {
      id
      atsDriverId
      category
      documentName
      driverId
      source
      type
      expirationDate
      atsDateCreated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAtsDriverDocuments = /* GraphQL */ `
  query ListAtsDriverDocuments(
    $filter: ModelAtsDriverDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAtsDriverDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        atsDriverId
        category
        documentName
        driverId
        source
        type
        expirationDate
        atsDateCreated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAtsDriverDocumentsByDriverIdBysourceByCategoryByType = /* GraphQL */ `
  query ListAtsDriverDocumentsByDriverIdBysourceByCategoryByType(
    $driverId: Int!
    $sourceCategoryType: ModelAtsDriverDocumentsByDriverIdBysourceByCategoryByTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAtsDriverDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAtsDriverDocumentsByDriverIdBysourceByCategoryByType(
      driverId: $driverId
      sourceCategoryType: $sourceCategoryType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        atsDriverId
        category
        documentName
        driverId
        source
        type
        expirationDate
        atsDateCreated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStandardDocuments = /* GraphQL */ `
  query GetStandardDocuments($id: ID!) {
    getStandardDocuments(id: $id) {
      id
      for
      forName
      category
      type
      customerId
      driverId
      documentName
      accountMasterCode
      createdAt
      updatedAt
      userStandardDocumentsId
      __typename
    }
  }
`;
export const listStandardDocuments = /* GraphQL */ `
  query ListStandardDocuments(
    $filter: ModelStandardDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStandardDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        for
        forName
        category
        type
        customerId
        driverId
        documentName
        accountMasterCode
        createdAt
        updatedAt
        userStandardDocumentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStandardDocumentsBySubjectByCategoryByType = /* GraphQL */ `
  query ListStandardDocumentsBySubjectByCategoryByType(
    $for: String!
    $customerIdDriverIdCategoryType: ModelStandardDocumentsBySubjectByCategoryByTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStandardDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStandardDocumentsBySubjectByCategoryByType(
      for: $for
      customerIdDriverIdCategoryType: $customerIdDriverIdCategoryType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        for
        forName
        category
        type
        customerId
        driverId
        documentName
        accountMasterCode
        createdAt
        updatedAt
        userStandardDocumentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStandardDocumentsBySubjectByaccountMasterCodeByCategoryByType = /* GraphQL */ `
  query ListStandardDocumentsBySubjectByaccountMasterCodeByCategoryByType(
    $for: String!
    $accountMasterCodeCustomerIdDriverIdCategoryType: ModelStandardDocumentsBySubjectByaccountMasterCodeByCategoryByTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStandardDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStandardDocumentsBySubjectByaccountMasterCodeByCategoryByType(
      for: $for
      accountMasterCodeCustomerIdDriverIdCategoryType: $accountMasterCodeCustomerIdDriverIdCategoryType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        for
        forName
        category
        type
        customerId
        driverId
        documentName
        accountMasterCode
        createdAt
        updatedAt
        userStandardDocumentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuestions = /* GraphQL */ `
  query GetQuestions($id: ID!) {
    getQuestions(id: $id) {
      id
      user
      text
      createUserFullName
      type
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      status
      createdAt
      updatedAt
      driverQualificationQuestionsId
      __typename
    }
  }
`;
export const listQuestions = /* GraphQL */ `
  query ListQuestions(
    $filter: ModelQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user
        text
        createUserFullName
        type
        driverQualification {
          id
          tier
          customerId
          name
          driverId
          driverName
          status
          jobId
          jobStartDate
          createEmail
          updateUser
          dqSpecialistUser
          dqSpecialistEmail
          createUserFullName
          dqOwnerFullName
          dqClientApproverUser
          dqClientApproverUserFullName
          dqDocumentName
          createdAt
          tierDescription
          branch
          driverSkillSummary
          accountMasterCode
          checkListLevel
          fileType
          clientVisible
          updatedAt
          driverQualificationLocationStateId
          driverQualificationLocationCityId
          __typename
        }
        status
        createdAt
        updatedAt
        driverQualificationQuestionsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDriverQualificationServiceTeamNotes = /* GraphQL */ `
  query GetDriverQualificationServiceTeamNotes($id: ID!) {
    getDriverQualificationServiceTeamNotes(id: $id) {
      id
      user
      text
      createUserFullName
      driverQualification {
        id
        tier
        customerId
        name
        driverId
        driverName
        status
        jobId
        jobStartDate
        createEmail
        updateUser
        dqSpecialistUser
        dqSpecialistEmail
        createUserFullName
        dqOwnerFullName
        dqClientApproverUser
        dqClientApproverUserFullName
        dqDocumentName
        questions {
          nextToken
          __typename
        }
        driverQualificationServiceTeamNotes {
          nextToken
          __typename
        }
        createdAt
        tierDescription
        branch
        driverSkillSummary
        locationState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        locationCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        driverQualificationChecklistDocuments {
          nextToken
          __typename
        }
        accountMasterCode
        checkListLevel
        fileType
        clientVisible
        updatedAt
        driverQualificationLocationStateId
        driverQualificationLocationCityId
        __typename
      }
      createdAt
      updatedAt
      driverQualificationDriverQualificationServiceTeamNotesId
      __typename
    }
  }
`;
export const listDriverQualificationServiceTeamNotes = /* GraphQL */ `
  query ListDriverQualificationServiceTeamNotes(
    $filter: ModelDriverQualificationServiceTeamNotesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverQualificationServiceTeamNotes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user
        text
        createUserFullName
        driverQualification {
          id
          tier
          customerId
          name
          driverId
          driverName
          status
          jobId
          jobStartDate
          createEmail
          updateUser
          dqSpecialistUser
          dqSpecialistEmail
          createUserFullName
          dqOwnerFullName
          dqClientApproverUser
          dqClientApproverUserFullName
          dqDocumentName
          createdAt
          tierDescription
          branch
          driverSkillSummary
          accountMasterCode
          checkListLevel
          fileType
          clientVisible
          updatedAt
          driverQualificationLocationStateId
          driverQualificationLocationCityId
          __typename
        }
        createdAt
        updatedAt
        driverQualificationDriverQualificationServiceTeamNotesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDriverQualificationAdditionalDocuments = /* GraphQL */ `
  query GetDriverQualificationAdditionalDocuments($id: ID!) {
    getDriverQualificationAdditionalDocuments(id: $id) {
      id
      driverQualificationAdditionalDocumentsId
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDriverQualificationAdditionalDocuments = /* GraphQL */ `
  query ListDriverQualificationAdditionalDocuments(
    $filter: ModelDriverQualificationAdditionalDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverQualificationAdditionalDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        driverQualificationAdditionalDocumentsId
        documentName
        originalFileName
        uploadedByEmail
        uploadedByFullName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAdditionalDocumentsByDqfId = /* GraphQL */ `
  query ListAdditionalDocumentsByDqfId(
    $driverQualificationAdditionalDocumentsId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDriverQualificationAdditionalDocumentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdditionalDocumentsByDqfId(
      driverQualificationAdditionalDocumentsId: $driverQualificationAdditionalDocumentsId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        driverQualificationAdditionalDocumentsId
        documentName
        originalFileName
        uploadedByEmail
        uploadedByFullName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAudit = /* GraphQL */ `
  query GetAudit($id: ID!) {
    getAudit(id: $id) {
      id
      event
      eventTime
      user {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      objectName
      objectId
      objectData
      createdAt
      updatedAt
      userAuditId
      __typename
    }
  }
`;
export const listAudits = /* GraphQL */ `
  query ListAudits(
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        event
        eventTime
        user {
          id
          name
          customerId
          status
          type
          lastLogin
          clientName
          updateDriverQualifications
          cellPhone
          passwordChangeDate
          preferredMFA
          lastResetMFA
          customersAddedByAmc
          createdAt
          updatedAt
          __typename
        }
        objectName
        objectId
        objectData
        createdAt
        updatedAt
        userAuditId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAuditbyObjectNamebyObjectId = /* GraphQL */ `
  query ListAuditbyObjectNamebyObjectId(
    $objectName: String!
    $objectId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuditbyObjectNamebyObjectId(
      objectName: $objectName
      objectId: $objectId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        event
        eventTime
        user {
          id
          name
          customerId
          status
          type
          lastLogin
          clientName
          updateDriverQualifications
          cellPhone
          passwordChangeDate
          preferredMFA
          lastResetMFA
          customersAddedByAmc
          createdAt
          updatedAt
          __typename
        }
        objectName
        objectId
        objectData
        createdAt
        updatedAt
        userAuditId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getApplication = /* GraphQL */ `
  query GetApplication($id: ID!) {
    getApplication(id: $id) {
      id
      name
      roles {
        items {
          id
          name
          usedBy
          applicationUsedBy
          viewFullPii
          createdAt
          updatedAt
          applicationRolesId
          __typename
        }
        nextToken
        __typename
      }
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listApplications = /* GraphQL */ `
  query ListApplications(
    $filter: ModelApplicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApplications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        roles {
          nextToken
          __typename
        }
        userAppAccess {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getApplicationRole = /* GraphQL */ `
  query GetApplicationRole($id: ID!) {
    getApplicationRole(id: $id) {
      id
      name
      usedBy
      userAppAccess {
        items {
          id
          createdAt
          updatedAt
          userAppAccessId
          applicationUserAppAccessId
          applicationRoleUserAppAccessId
          __typename
        }
        nextToken
        __typename
      }
      applicationUsedBy
      viewFullPii
      createdAt
      updatedAt
      applicationRolesId
      __typename
    }
  }
`;
export const listApplicationRoles = /* GraphQL */ `
  query ListApplicationRoles(
    $filter: ModelApplicationRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApplicationRoles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        usedBy
        userAppAccess {
          nextToken
          __typename
        }
        applicationUsedBy
        viewFullPii
        createdAt
        updatedAt
        applicationRolesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserApplicationAccess = /* GraphQL */ `
  query GetUserApplicationAccess($id: ID!) {
    getUserApplicationAccess(id: $id) {
      id
      userId {
        id
        name
        customerId
        status
        type
        lastLogin
        clientName
        updateDriverQualifications
        StandardDocuments {
          nextToken
          __typename
        }
        Audit {
          nextToken
          __typename
        }
        appAccess {
          nextToken
          __typename
        }
        cellPhone
        passwordChangeDate
        preferredMFA
        lastResetMFA
        customersAddedByAmc
        customers {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      appId {
        id
        name
        roles {
          nextToken
          __typename
        }
        userAppAccess {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      roleId {
        id
        name
        usedBy
        userAppAccess {
          nextToken
          __typename
        }
        applicationUsedBy
        viewFullPii
        createdAt
        updatedAt
        applicationRolesId
        __typename
      }
      createdAt
      updatedAt
      userAppAccessId
      applicationUserAppAccessId
      applicationRoleUserAppAccessId
      __typename
    }
  }
`;
export const listUserApplicationAccesses = /* GraphQL */ `
  query ListUserApplicationAccesses(
    $filter: ModelUserApplicationAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserApplicationAccesses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId {
          id
          name
          customerId
          status
          type
          lastLogin
          clientName
          updateDriverQualifications
          cellPhone
          passwordChangeDate
          preferredMFA
          lastResetMFA
          customersAddedByAmc
          createdAt
          updatedAt
          __typename
        }
        appId {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        roleId {
          id
          name
          usedBy
          applicationUsedBy
          viewFullPii
          createdAt
          updatedAt
          applicationRolesId
          __typename
        }
        createdAt
        updatedAt
        userAppAccessId
        applicationUserAppAccessId
        applicationRoleUserAppAccessId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      ApplicationId
      Event
      UserId
      ObjectId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ApplicationId
        Event
        UserId
        ObjectId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getManual = /* GraphQL */ `
  query GetManual($id: ID!) {
    getManual(id: $id) {
      id
      portal
      title
      documentName
      originalFileName
      fileType
      fileSize
      active
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listManuals = /* GraphQL */ `
  query ListManuals(
    $filter: ModelManualFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listManuals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        portal
        title
        documentName
        originalFileName
        fileType
        fileSize
        active
        uploadedByEmail
        uploadedByFullName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocumentSubject = /* GraphQL */ `
  query GetDocumentSubject($id: ID!) {
    getDocumentSubject(id: $id) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocumentSubjects = /* GraphQL */ `
  query ListDocumentSubjects(
    $filter: ModelDocumentSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocumentSubjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocumentSource = /* GraphQL */ `
  query GetDocumentSource($id: ID!) {
    getDocumentSource(id: $id) {
      id
      name
      category {
        items {
          id
          name
          createdAt
          updatedAt
          documentSourceCategoryId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocumentSources = /* GraphQL */ `
  query ListDocumentSources(
    $filter: ModelDocumentSourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocumentSources(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        category {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocumentCategory = /* GraphQL */ `
  query GetDocumentCategory($id: ID!) {
    getDocumentCategory(id: $id) {
      id
      name
      type {
        items {
          id
          Name
          For
          createdAt
          updatedAt
          documentCategoryTypeId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      documentSourceCategoryId
      __typename
    }
  }
`;
export const listDocumentCategories = /* GraphQL */ `
  query ListDocumentCategories(
    $filter: ModelDocumentCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocumentCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        documentSourceCategoryId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocumentType = /* GraphQL */ `
  query GetDocumentType($id: ID!) {
    getDocumentType(id: $id) {
      id
      Name
      For
      createdAt
      updatedAt
      documentCategoryTypeId
      __typename
    }
  }
`;
export const listDocumentTypes = /* GraphQL */ `
  query ListDocumentTypes(
    $filter: ModelDocumentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocumentTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Name
        For
        createdAt
        updatedAt
        documentCategoryTypeId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getChecklist = /* GraphQL */ `
  query GetChecklist($id: ID!) {
    getChecklist(id: $id) {
      id
      tier
      clientId
      clientName
      checklistDocumentName
      accountMasterCode
      checkListLevel
      items {
        items {
          id
          item
          source
          category
          type
          pages
          order
          createdAt
          updatedAt
          checklistItemsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listChecklists = /* GraphQL */ `
  query ListChecklists(
    $filter: ModelChecklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tier
        clientId
        clientName
        checklistDocumentName
        accountMasterCode
        checkListLevel
        items {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listChecklistByClientIdTier = /* GraphQL */ `
  query ListChecklistByClientIdTier(
    $clientId: Int!
    $tier: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChecklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklistByClientIdTier(
      clientId: $clientId
      tier: $tier
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tier
        clientId
        clientName
        checklistDocumentName
        accountMasterCode
        checkListLevel
        items {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listChecklistBycheckListLevelAccountMasterCodeClientIdTier = /* GraphQL */ `
  query ListChecklistBycheckListLevelAccountMasterCodeClientIdTier(
    $checkListLevel: String!
    $accountMasterCodeClientIdTier: ModelChecklistBycheckListLevelbyAccountMasterCodebyClientIdTierCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChecklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklistBycheckListLevelAccountMasterCodeClientIdTier(
      checkListLevel: $checkListLevel
      accountMasterCodeClientIdTier: $accountMasterCodeClientIdTier
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        tier
        clientId
        clientName
        checklistDocumentName
        accountMasterCode
        checkListLevel
        items {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getChecklistItems = /* GraphQL */ `
  query GetChecklistItems($id: ID!) {
    getChecklistItems(id: $id) {
      id
      item
      source
      category
      type
      pages
      order
      createdAt
      updatedAt
      checklistItemsId
      __typename
    }
  }
`;
export const listChecklistItems = /* GraphQL */ `
  query ListChecklistItems(
    $filter: ModelChecklistItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklistItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        item
        source
        category
        type
        pages
        order
        createdAt
        updatedAt
        checklistItemsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAiClientQualification = /* GraphQL */ `
  query GetAiClientQualification($id: ID!) {
    getAiClientQualification(id: $id) {
      id
      qualLevel
      clientId
      clientName
      accountMasterCode
      amcName
      category
      rulesKey
      rulesGeneratedAt
      rulesStatus
      createdAt
      documents {
        items {
          id
          documentName
          originalFileName
          uploadedByEmail
          uploadedByFullName
          createdAt
          updatedAt
          aiClientQualificationDocumentsId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listAiClientQualifications = /* GraphQL */ `
  query ListAiClientQualifications(
    $filter: ModelAiClientQualificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAiClientQualifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        qualLevel
        clientId
        clientName
        accountMasterCode
        amcName
        category
        rulesKey
        rulesGeneratedAt
        rulesStatus
        createdAt
        documents {
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAiClientQualificationsByLevel = /* GraphQL */ `
  query ListAiClientQualificationsByLevel(
    $qualLevel: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAiClientQualificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAiClientQualificationsByLevel(
      qualLevel: $qualLevel
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        qualLevel
        clientId
        clientName
        accountMasterCode
        amcName
        category
        rulesKey
        rulesGeneratedAt
        rulesStatus
        createdAt
        documents {
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAiClientQualificationsByClientId = /* GraphQL */ `
  query ListAiClientQualificationsByClientId(
    $clientId: Int!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAiClientQualificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAiClientQualificationsByClientId(
      clientId: $clientId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        qualLevel
        clientId
        clientName
        accountMasterCode
        amcName
        category
        rulesKey
        rulesGeneratedAt
        rulesStatus
        createdAt
        documents {
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAiClientQualificationDocument = /* GraphQL */ `
  query GetAiClientQualificationDocument($id: ID!) {
    getAiClientQualificationDocument(id: $id) {
      id
      documentName
      originalFileName
      uploadedByEmail
      uploadedByFullName
      createdAt
      updatedAt
      aiClientQualificationDocumentsId
      __typename
    }
  }
`;
export const listAiClientQualificationDocuments = /* GraphQL */ `
  query ListAiClientQualificationDocuments(
    $filter: ModelAiClientQualificationDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAiClientQualificationDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        documentName
        originalFileName
        uploadedByEmail
        uploadedByFullName
        createdAt
        updatedAt
        aiClientQualificationDocumentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAiPrompt = /* GraphQL */ `
  query GetAiPrompt($id: ID!) {
    getAiPrompt(id: $id) {
      id
      promptKey
      version
      body
      active
      updatedByEmail
      updatedByFullName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAiPrompts = /* GraphQL */ `
  query ListAiPrompts(
    $filter: ModelAiPromptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAiPrompts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        promptKey
        version
        body
        active
        updatedByEmail
        updatedByFullName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAiPromptsByKey = /* GraphQL */ `
  query ListAiPromptsByKey(
    $promptKey: String!
    $version: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAiPromptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAiPromptsByKey(
      promptKey: $promptKey
      version: $version
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        promptKey
        version
        body
        active
        updatedByEmail
        updatedByFullName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDqfAudit = /* GraphQL */ `
  query GetDqfAudit($id: ID!) {
    getDqfAudit(id: $id) {
      id
      dqfId
      customerId
      status
      resultNote
      qualListAvailable
      qualListId
      promptVersion
      model
      effort
      reviewDate
      exceptions
      exceptionCount
      inputTokens
      outputTokens
      processingTimeMs
      requestId
      errorMessage
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDqfAudits = /* GraphQL */ `
  query ListDqfAudits(
    $filter: ModelDqfAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDqfAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dqfId
        customerId
        status
        resultNote
        qualListAvailable
        qualListId
        promptVersion
        model
        effort
        reviewDate
        exceptions
        exceptionCount
        inputTokens
        outputTokens
        processingTimeMs
        requestId
        errorMessage
        createdBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDqfAuditsByDqfId = /* GraphQL */ `
  query ListDqfAuditsByDqfId(
    $dqfId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDqfAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDqfAuditsByDqfId(
      dqfId: $dqfId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dqfId
        customerId
        status
        resultNote
        qualListAvailable
        qualListId
        promptVersion
        model
        effort
        reviewDate
        exceptions
        exceptionCount
        inputTokens
        outputTokens
        processingTimeMs
        requestId
        errorMessage
        createdBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAirLine = /* GraphQL */ `
  query GetAirLine($id: ID!) {
    getAirLine(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAirLines = /* GraphQL */ `
  query ListAirLines(
    $filter: ModelAirLineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAirLines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAirPort = /* GraphQL */ `
  query GetAirPort($id: ID!) {
    getAirPort(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAirPorts = /* GraphQL */ `
  query ListAirPorts(
    $filter: ModelAirPortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAirPorts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHotel = /* GraphQL */ `
  query GetHotel($id: ID!) {
    getHotel(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHotels = /* GraphQL */ `
  query ListHotels(
    $filter: ModelHotelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHotels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCarRental = /* GraphQL */ `
  query GetCarRental($id: ID!) {
    getCarRental(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCarRentals = /* GraphQL */ `
  query ListCarRentals(
    $filter: ModelCarRentalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarRentals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getState = /* GraphQL */ `
  query GetState($id: ID!) {
    getState(id: $id) {
      id
      name
      city {
        items {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStates = /* GraphQL */ `
  query ListStates(
    $filter: ModelStateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCity = /* GraphQL */ `
  query GetCity($id: ID!) {
    getCity(id: $id) {
      id
      state {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      status
      createdAt
      updatedAt
      stateCityId
      __typename
    }
  }
`;
export const listCities = /* GraphQL */ `
  query ListCities(
    $filter: ModelCityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExpense = /* GraphQL */ `
  query GetExpense($id: ID!) {
    getExpense(id: $id) {
      id
      code
      driverId
      driverName
      assignmentId
      status
      nonBillable
      customerId
      customerName
      branch
      branchName
      costCenter
      startDate
      endDate
      totalToBeBilled
      notes
      auditKey
      invoiceDate
      invoiceNumber
      invoicePaid
      amountBilled
      variance
      statementDate
      expenseReportAppropriationNbr
      expenseItem {
        items {
          id
          flightDate
          paidThrough
          creditCardHolderName
          receiptAmount
          markup
          expenseTotal
          documentName
          documentSize
          uploadedByName
          uploadedDate
          hotelConfirmationNumber
          hotelPhoneNumber
          hotelStreetAddress
          checkInDate
          lastNightOfStay
          dailyCharge
          totalReceiptAmount
          carRentalContractNumber
          carRentalPickUpLocation
          carRentalReturnLocation
          carRentalPickUpDate
          carRentalReturnDate
          originalReceiptAmount
          otherExpenseName
          otherExpenseDescription
          otherExpenseDate
          hotelDriverId
          hotelDriverName
          hotelAssignmentId
          projectedDays
          projectedAmount
          createdAt
          updatedAt
          expenseExpenseItemId
          expenseItemAirLineId
          expenseItemDepartureAirPortId
          expenseItemArrivalAirPortId
          expenseItemHotelId
          expenseItemHotelStateId
          expenseItemHotelCityId
          expenseItemCarRentalCompanyId
          __typename
        }
        nextToken
        __typename
      }
      sharedInvoice
      createdAt
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      documentName
      documentSize
      uploadedByName
      uploadedDate
      totalReceiptAmount
      totalProjectedAmount
      checkedForUltraStaff
      inv
      payType
      payAmt
      billUnits
      ok
      payWeekEnding
      originalExpenseId
      correctionExpenseId
      rebilledExpenseId
      flatFeeBilling
      lob
      confirmedBy
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const listExpenses = /* GraphQL */ `
  query ListExpenses(
    $filter: ModelExpenseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExpenses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        driverId
        driverName
        assignmentId
        status
        nonBillable
        customerId
        customerName
        branch
        branchName
        costCenter
        startDate
        endDate
        totalToBeBilled
        notes
        auditKey
        invoiceDate
        invoiceNumber
        invoicePaid
        amountBilled
        variance
        statementDate
        expenseReportAppropriationNbr
        expenseItem {
          nextToken
          __typename
        }
        sharedInvoice
        createdAt
        hotel {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        hotelConfirmationNumber
        hotelPhoneNumber
        hotelStreetAddress
        hotelState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        hotelCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        documentName
        documentSize
        uploadedByName
        uploadedDate
        totalReceiptAmount
        totalProjectedAmount
        checkedForUltraStaff
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        originalExpenseId
        correctionExpenseId
        rebilledExpenseId
        flatFeeBilling
        lob
        confirmedBy
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExpenseItem = /* GraphQL */ `
  query GetExpenseItem($id: ID!) {
    getExpenseItem(id: $id) {
      id
      expense {
        id
        code
        driverId
        driverName
        assignmentId
        status
        nonBillable
        customerId
        customerName
        branch
        branchName
        costCenter
        startDate
        endDate
        totalToBeBilled
        notes
        auditKey
        invoiceDate
        invoiceNumber
        invoicePaid
        amountBilled
        variance
        statementDate
        expenseReportAppropriationNbr
        expenseItem {
          nextToken
          __typename
        }
        sharedInvoice
        createdAt
        hotel {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        hotelConfirmationNumber
        hotelPhoneNumber
        hotelStreetAddress
        hotelState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        hotelCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        documentName
        documentSize
        uploadedByName
        uploadedDate
        totalReceiptAmount
        totalProjectedAmount
        checkedForUltraStaff
        inv
        payType
        payAmt
        billUnits
        ok
        payWeekEnding
        originalExpenseId
        correctionExpenseId
        rebilledExpenseId
        flatFeeBilling
        lob
        confirmedBy
        updatedBy
        updatedAt
        __typename
      }
      airLine {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      departureAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      arrivalAirPort {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      flightDate
      paidThrough
      creditCardHolderName
      receiptAmount
      markup
      expenseTotal
      documentName
      documentSize
      uploadedByName
      uploadedDate
      hotel {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      hotelConfirmationNumber
      hotelPhoneNumber
      hotelStreetAddress
      hotelState {
        id
        name
        city {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      hotelCity {
        id
        state {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        name
        status
        createdAt
        updatedAt
        stateCityId
        __typename
      }
      checkInDate
      lastNightOfStay
      dailyCharge
      totalReceiptAmount
      carRentalCompany {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      carRentalContractNumber
      carRentalPickUpLocation
      carRentalReturnLocation
      carRentalPickUpDate
      carRentalReturnDate
      originalReceiptAmount
      otherExpenseName
      otherExpenseDescription
      otherExpenseDate
      hotelDriverId
      hotelDriverName
      hotelAssignmentId
      projectedDays
      projectedAmount
      createdAt
      updatedAt
      expenseExpenseItemId
      expenseItemAirLineId
      expenseItemDepartureAirPortId
      expenseItemArrivalAirPortId
      expenseItemHotelId
      expenseItemHotelStateId
      expenseItemHotelCityId
      expenseItemCarRentalCompanyId
      __typename
    }
  }
`;
export const listExpenseItems = /* GraphQL */ `
  query ListExpenseItems(
    $filter: ModelExpenseItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExpenseItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        expense {
          id
          code
          driverId
          driverName
          assignmentId
          status
          nonBillable
          customerId
          customerName
          branch
          branchName
          costCenter
          startDate
          endDate
          totalToBeBilled
          notes
          auditKey
          invoiceDate
          invoiceNumber
          invoicePaid
          amountBilled
          variance
          statementDate
          expenseReportAppropriationNbr
          sharedInvoice
          createdAt
          hotelConfirmationNumber
          hotelPhoneNumber
          hotelStreetAddress
          documentName
          documentSize
          uploadedByName
          uploadedDate
          totalReceiptAmount
          totalProjectedAmount
          checkedForUltraStaff
          inv
          payType
          payAmt
          billUnits
          ok
          payWeekEnding
          originalExpenseId
          correctionExpenseId
          rebilledExpenseId
          flatFeeBilling
          lob
          confirmedBy
          updatedBy
          updatedAt
          __typename
        }
        airLine {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        departureAirPort {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        arrivalAirPort {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        flightDate
        paidThrough
        creditCardHolderName
        receiptAmount
        markup
        expenseTotal
        documentName
        documentSize
        uploadedByName
        uploadedDate
        hotel {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        hotelConfirmationNumber
        hotelPhoneNumber
        hotelStreetAddress
        hotelState {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        hotelCity {
          id
          name
          status
          createdAt
          updatedAt
          stateCityId
          __typename
        }
        checkInDate
        lastNightOfStay
        dailyCharge
        totalReceiptAmount
        carRentalCompany {
          id
          name
          status
          createdAt
          updatedAt
          __typename
        }
        carRentalContractNumber
        carRentalPickUpLocation
        carRentalReturnLocation
        carRentalPickUpDate
        carRentalReturnDate
        originalReceiptAmount
        otherExpenseName
        otherExpenseDescription
        otherExpenseDate
        hotelDriverId
        hotelDriverName
        hotelAssignmentId
        projectedDays
        projectedAmount
        createdAt
        updatedAt
        expenseExpenseItemId
        expenseItemAirLineId
        expenseItemDepartureAirPortId
        expenseItemArrivalAirPortId
        expenseItemHotelId
        expenseItemHotelStateId
        expenseItemHotelCityId
        expenseItemCarRentalCompanyId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTATQuiz = /* GraphQL */ `
  query GetTATQuiz($id: ID!) {
    getTATQuiz(id: $id) {
      id
      livesOfPotentialVictims
      isTraffickingInTheUntiedStates
      whereTraffickingHappen
      victimsNeedAidInTheirRecovery
      humanTraffickingIsExploitation
      traffickersGroomPotentialVictims
      vulnerabilityFactors
      minorsSellingSexIsProstitution
      redFlagsToWatchOutFor
      crimesInProgress
      certificate
      status
      attempts
      employeeFullName
      emailNotificationStatus
      emailNotificationDateTime
      firstName
      lastName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTATQuizs = /* GraphQL */ `
  query ListTATQuizs(
    $filter: ModelTATQuizFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTATQuizs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        livesOfPotentialVictims
        isTraffickingInTheUntiedStates
        whereTraffickingHappen
        victimsNeedAidInTheirRecovery
        humanTraffickingIsExploitation
        traffickersGroomPotentialVictims
        vulnerabilityFactors
        minorsSellingSexIsProstitution
        redFlagsToWatchOutFor
        crimesInProgress
        certificate
        status
        attempts
        employeeFullName
        emailNotificationStatus
        emailNotificationDateTime
        firstName
        lastName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPushNotification = /* GraphQL */ `
  query GetPushNotification($id: ID!) {
    getPushNotification(id: $id) {
      id
      type
      subject
      message
      url
      status
      lob
      branch
      recipientStatus
      approvedBy
      approvedAt
      sentOn
      createdAt
      createdBy
      updatedAt
      __typename
    }
  }
`;
export const listPushNotifications = /* GraphQL */ `
  query ListPushNotifications(
    $filter: ModelPushNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPushNotifications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        subject
        message
        url
        status
        lob
        branch
        recipientStatus
        approvedBy
        approvedAt
        sentOn
        createdAt
        createdBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listByTypeByCreatedAt = /* GraphQL */ `
  query ListByTypeByCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPushNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listByTypeByCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        subject
        message
        url
        status
        lob
        branch
        recipientStatus
        approvedBy
        approvedAt
        sentOn
        createdAt
        createdBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBenefitClassCode = /* GraphQL */ `
  query GetBenefitClassCode($id: ID!) {
    getBenefitClassCode(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBenefitClassCodes = /* GraphQL */ `
  query ListBenefitClassCodes(
    $filter: ModelBenefitClassCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBenefitClassCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBenefitDivisionCode = /* GraphQL */ `
  query GetBenefitDivisionCode($id: ID!) {
    getBenefitDivisionCode(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBenefitDivisionCodes = /* GraphQL */ `
  query ListBenefitDivisionCodes(
    $filter: ModelBenefitDivisionCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBenefitDivisionCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBenefitPlanType = /* GraphQL */ `
  query GetBenefitPlanType($id: ID!) {
    getBenefitPlanType(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBenefitPlanTypes = /* GraphQL */ `
  query ListBenefitPlanTypes(
    $filter: ModelBenefitPlanTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBenefitPlanTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBenefitTypeOfCoverage = /* GraphQL */ `
  query GetBenefitTypeOfCoverage($id: ID!) {
    getBenefitTypeOfCoverage(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBenefitTypeOfCoverages = /* GraphQL */ `
  query ListBenefitTypeOfCoverages(
    $filter: ModelBenefitTypeOfCoverageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBenefitTypeOfCoverages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDmsDriver = /* GraphQL */ `
  query GetDmsDriver($id: ID!) {
    getDmsDriver(id: $id) {
      id
      driverId
      firstName
      lastName
      lob
      currentClientId
      currentClientName
      latestActivityEndDate
      serviceAction
      benefitsAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDmsDrivers = /* GraphQL */ `
  query ListDmsDrivers(
    $filter: ModelDmsDriverFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDmsDrivers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        driverId
        firstName
        lastName
        lob
        currentClientId
        currentClientName
        latestActivityEndDate
        serviceAction
        benefitsAction
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDmsContractActivity = /* GraphQL */ `
  query GetDmsContractActivity($id: ID!) {
    getDmsContractActivity(id: $id) {
      id
      driverId
      driverName
      lob
      branch
      recruiterRpc
      enteredDate
      contractStartDate
      contractEndDate
      jobOrderId
      clientId
      clientName
      portalStatus
      forPayroll
      clearServiceActionFlag
      clearBenefitActionFlag
      payRate
      payRateUnit
      payType
      salaryAmount
      fullOrPartTime
      benefitsElection
      notes
      benefitEffectiveDate
      benefitTerminationDate
      benefitTimeStatus
      medPolicy
      typeOfCoverage
      planType
      benefitClassCode
      benefitDivisionCode
      billingCycle
      billingAmount
      medicalContractActivityId
      medicalJobOrderId
      medicalContractStartDate
      medicalContractEndDate
      medicalFillDate
      medicalFillPc
      startBenSentDate
      termBenSentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDmsContractActivities = /* GraphQL */ `
  query ListDmsContractActivities(
    $filter: ModelDmsContractActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDmsContractActivities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        driverId
        driverName
        lob
        branch
        recruiterRpc
        enteredDate
        contractStartDate
        contractEndDate
        jobOrderId
        clientId
        clientName
        portalStatus
        forPayroll
        clearServiceActionFlag
        clearBenefitActionFlag
        payRate
        payRateUnit
        payType
        salaryAmount
        fullOrPartTime
        benefitsElection
        notes
        benefitEffectiveDate
        benefitTerminationDate
        benefitTimeStatus
        medPolicy
        typeOfCoverage
        planType
        benefitClassCode
        benefitDivisionCode
        billingCycle
        billingAmount
        medicalContractActivityId
        medicalJobOrderId
        medicalContractStartDate
        medicalContractEndDate
        medicalFillDate
        medicalFillPc
        startBenSentDate
        termBenSentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDmsContractActivitiesByDriverIdByContractStartDate = /* GraphQL */ `
  query ListDmsContractActivitiesByDriverIdByContractStartDate(
    $driverId: Int!
    $contractStartDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDmsContractActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDmsContractActivitiesByDriverIdByContractStartDate(
      driverId: $driverId
      contractStartDate: $contractStartDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        driverId
        driverName
        lob
        branch
        recruiterRpc
        enteredDate
        contractStartDate
        contractEndDate
        jobOrderId
        clientId
        clientName
        portalStatus
        forPayroll
        clearServiceActionFlag
        clearBenefitActionFlag
        payRate
        payRateUnit
        payType
        salaryAmount
        fullOrPartTime
        benefitsElection
        notes
        benefitEffectiveDate
        benefitTerminationDate
        benefitTimeStatus
        medPolicy
        typeOfCoverage
        planType
        benefitClassCode
        benefitDivisionCode
        billingCycle
        billingAmount
        medicalContractActivityId
        medicalJobOrderId
        medicalContractStartDate
        medicalContractEndDate
        medicalFillDate
        medicalFillPc
        startBenSentDate
        termBenSentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTimeOffRequest = /* GraphQL */ `
  query GetTimeOffRequest($id: ID!) {
    getTimeOffRequest(id: $id) {
      id
      employeeId
      employeeName
      customerId
      customerName
      startDate
      endDate
      reason
      employeeComment
      serviceComment
      status
      approvedByUserId
      approvedByUserName
      cancelledByUserId
      cancelledByUserName
      declinedByUserId
      declinedByUserName
      resetByUserId
      resetByUserName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTimeOffRequests = /* GraphQL */ `
  query ListTimeOffRequests(
    $filter: ModelTimeOffRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeOffRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employeeId
        employeeName
        customerId
        customerName
        startDate
        endDate
        reason
        employeeComment
        serviceComment
        status
        approvedByUserId
        approvedByUserName
        cancelledByUserId
        cancelledByUserName
        declinedByUserId
        declinedByUserName
        resetByUserId
        resetByUserName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTimeOffRequestsByEmployeeIdByStartDate = /* GraphQL */ `
  query ListTimeOffRequestsByEmployeeIdByStartDate(
    $employeeId: Int!
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeOffRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeOffRequestsByEmployeeIdByStartDate(
      employeeId: $employeeId
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        employeeName
        customerId
        customerName
        startDate
        endDate
        reason
        employeeComment
        serviceComment
        status
        approvedByUserId
        approvedByUserName
        cancelledByUserId
        cancelledByUserName
        declinedByUserId
        declinedByUserName
        resetByUserId
        resetByUserName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
